import {
  REPORTS_TRANSACTIONS_SET_TRANSACTIONS,
  REPORTS_TRANSACTIONS_SET_TRANSACTION_DETAIL,
  REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_NON_MOBILE,
  REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL,
  REPORTS_TRANSACTIONS_TRANSACTIONS_REQUEST,
  REPORTS_TRANSACTIONS_PAGE_REQUEST,
  REPORTS_TRANSACTIONS_CHANGE_OUTLET,
  REPORTS_TRANSACTIONS_CHANGE_DATE,
  REPORTS_TRANSACTIONS_SHOW_RESEND_EMAIL_MODAL,
  REPORTS_TRANSACTIONS_HIDE_RESEND_EMAIL_MODAL,
  REPORTS_TRANSACTIONS_SHOW_TRANSACTION_DETAIL_MODAL,
  REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL_MODAL,
  REPORTS_TRANSACTIONS_SEND_EMAIL_RECEIPT,
  REPORTS_TRANSACTIONS_SHOW_REFUND_BREAKDOWN_MODAL,
  REPORTS_TRANSACTIONS_HIDE_REFUND_BREAKDOWN_MODAL,
  REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS,
  REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_MOBILE,
  REPORTS_TRANSACTIONS_ISSUE_REFUND_REQUEST,
  REPORTS_TRANSACTIONS_SHOW_OLD_REFUND_MODAL,
  REPORTS_TRANSACTIONS_HIDE_OLD_REFUND_MODAL,
  REPORTS_TRANSACTIONS_EXPORT_TRANSACTION,
  REPORTS_TRANSACTIONS_ISSUE_OLD_REFUND_REQUEST,
  REPORTS_TRANSACTIONS_SET_OUTLETS,
  REPORTS_TRANSACTIONS_CHANGE_KEYWORD,
  REPORTS_TRANSACTIONS_SHOW_SET_QUANTITY_MODAL,
  REPORTS_TRANSACTIONS_HIDE_SET_QUANTITY_MODAL,
  REPORTS_TRANSACTIONS_ASK_SET_QUANTITY,
  REPORTS_TRANSACTIONS_CONFIRM_SET_QUANTITY,
  REPORTS_TRANSACTIONS_CANCEL_SET_QUANTITY,
  REPORTS_TRANSACTIONS_CANCEL_RESEND_EMAIL,
  REPORTS_TRANSACTIONS_CANCEL_REFUND_BREAKDOWN,
  REPORTS_TRANSACTIONS_SHOW_LOADING_SPINNER,
  REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS_PROMO,
} from './constants';

/** ******************************************************************************
 * Transactions
 ******************************************************************************* */

/**
 * @return {{type, payload: {}}}
 */
export function pageRequest() {
  return { type: REPORTS_TRANSACTIONS_PAGE_REQUEST, payload: {} };
}

/**
 * @param {object} query additional query params
 * @return {{type, payload: {query: *}}}
 */
export function getTransactionsRequest(query) {
  return {
    type: REPORTS_TRANSACTIONS_TRANSACTIONS_REQUEST,
    payload: { query },
  };
}

/**
 * @return {{type, payload: {transactions: *}}}
 */
export function setTransactions(transactions) {
  return {
    type: REPORTS_TRANSACTIONS_SET_TRANSACTIONS,
    payload: { transactions },
  };
}

/** ******************************************************************************
 * End Transactions
 ******************************************************************************* */

/** ******************************************************************************
 * Change handler
 ******************************************************************************* */

/**
 * @param {Array} outletIds
 */
export function changeOutlet(outletIds) {
  return { type: REPORTS_TRANSACTIONS_CHANGE_OUTLET, payload: { outletIds } };
}

/**
 * @param {Date} startDate
 * @param {Date} endDate
 */
export function changeDate(startDate, endDate) {
  return {
    type: REPORTS_TRANSACTIONS_CHANGE_DATE,
    payload: { startDate, endDate },
  };
}

/**
 *
 * @param keyword
 * @param startDate
 * @param endDate
 * @return {{type, payload: {keyword: *, startDate: *, endDate: *}}}
 */
export function changeKeyword({ keyword, startDate, endDate }) {
  return {
    type: REPORTS_TRANSACTIONS_CHANGE_KEYWORD,
    payload: { keyword, startDate, endDate },
  };
}
/** ******************************************************************************
 * End Change handler
 ******************************************************************************* */

/** ******************************************************************************
 * Transaction Detail
 ******************************************************************************* */

/**
 * @param {int} id transaction detail id
 * @param {object} query additional query params
 * @return {{type, payload: {id: *, query: *}}}
 */
export function showTransactionDetailRequestNonMobile(id, query) {
  return {
    type: REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_NON_MOBILE,
    payload: { id, query },
  };
}

/**
 * @param {int} id transaction detail id
 * @param {object} query additional query params
 * @return {{type, payload: {id: *, query: *}}}
 */
export function showTransactionDetailRequestMobile(id, query) {
  return {
    type: REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_MOBILE,
    payload: { id, query },
  };
}

export function hideTransactionDetail() {
  return { type: REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL, payload: {} };
}

/**
 *
 * @param {object} transactionDetail
 * @return {{type, payload: {transactionDetail: *}}}
 */
export function setTransactionDetail(transactionDetail) {
  return {
    type: REPORTS_TRANSACTIONS_SET_TRANSACTION_DETAIL,
    payload: { transactionDetail },
  };
}

export function showTransactionDetailModal() {
  return {
    type: REPORTS_TRANSACTIONS_SHOW_TRANSACTION_DETAIL_MODAL,
    payload: {},
  };
}

export function hideTransactionDetailModal() {
  return {
    type: REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL_MODAL,
    payload: {},
  };
}

/** ******************************************************************************
 * End Transaction Detail
 ******************************************************************************* */

/** ******************************************************************************
 * Resend Email
 ******************************************************************************* */

export function showResendEmailModal() {
  return { type: REPORTS_TRANSACTIONS_SHOW_RESEND_EMAIL_MODAL, payload: {} };
}

export function hideResendEmailModal() {
  return { type: REPORTS_TRANSACTIONS_HIDE_RESEND_EMAIL_MODAL, payload: {} };
}

export function sendEmailReceipt(data) {
  return { type: REPORTS_TRANSACTIONS_SEND_EMAIL_RECEIPT, payload: { data } };
}

/** ******************************************************************************
 * End Resend Email
 ******************************************************************************* */

/** ******************************************************************************
 * Refund Breakdown
 ******************************************************************************* */

export function showRefundBreakdownModal() {
  return {
    type: REPORTS_TRANSACTIONS_SHOW_REFUND_BREAKDOWN_MODAL,
    payload: {},
  };
}

export function hideRefundBreakdownModal() {
  return {
    type: REPORTS_TRANSACTIONS_HIDE_REFUND_BREAKDOWN_MODAL,
    payload: {},
  };
}

/**
 *
 * @param {object} items key-value object where key is item_id and value is extracted from
 * @see {@link transactionDetailNonMobileFlow}
 * @return {{type, payload: {items: *}}}
 */
export function setRefundItems(items) {
  return {
    type: REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS,
    payload: { items },
  };
}

export function issueRefundRequest(data) {
  return { type: REPORTS_TRANSACTIONS_ISSUE_REFUND_REQUEST, payload: { data } };
}

export function showSetQuantityModal() {
  return { type: REPORTS_TRANSACTIONS_SHOW_SET_QUANTITY_MODAL, payload: {} };
}

export function hideSetQuantityModal() {
  return { type: REPORTS_TRANSACTIONS_HIDE_SET_QUANTITY_MODAL, payload: {} };
}

export function askSetQuantity(refundItemsIdx, salesTypeName, refundAmount) {
  return {
    type: REPORTS_TRANSACTIONS_ASK_SET_QUANTITY,
    payload: { refundItemsIdx, salesTypeName, refundAmount },
  };
}

/**
 * @return {{type, payload: {refundItems: *}}}
 */
export function confirmSetQuantity(refundItems) {
  return {
    type: REPORTS_TRANSACTIONS_CONFIRM_SET_QUANTITY,
    payload: { refundItems },
  };
}

export function cancelSetQuantity() {
  return { type: REPORTS_TRANSACTIONS_CANCEL_SET_QUANTITY, payload: {} };
}

export function setRefundItemsPromo(itemsPromo) {
  return {
    type: REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS_PROMO,
    payload: { itemsPromo },
  };
}
/** ******************************************************************************
 * End Refund Breakdown
 ******************************************************************************* */

/** ******************************************************************************
 * Old Refund
 ******************************************************************************* */

export function showOldRefundModal() {
  return { type: REPORTS_TRANSACTIONS_SHOW_OLD_REFUND_MODAL, payload: {} };
}

export function hideOldRefundModal() {
  return { type: REPORTS_TRANSACTIONS_HIDE_OLD_REFUND_MODAL, payload: {} };
}

export function issueOldRefundRequest(data) {
  return {
    type: REPORTS_TRANSACTIONS_ISSUE_OLD_REFUND_REQUEST,
    payload: { data },
  };
}

/** ******************************************************************************
 * End Old Refund
 ******************************************************************************* */

/** ******************************************************************************
 * Export Transaction
 ******************************************************************************* */

/**
 * @param {object} query query params sent to the api call of export_transactions
 * @param {string} filename the filename that will be fetched after invocation of export_transactions api call
 * @param {int} outletId the outlet id that will be checked if export is already finished
 */
export function exportTransaction(params) {
  return { type: REPORTS_TRANSACTIONS_EXPORT_TRANSACTION, payload: { params } };
}

/** ******************************************************************************
 * End Export Transaction
 ******************************************************************************* */

export function setOutlets(outlets) {
  return { type: REPORTS_TRANSACTIONS_SET_OUTLETS, payload: { outlets } };
}

export function cancelResendEmail(transactionDetail) {
  return {
    type: REPORTS_TRANSACTIONS_CANCEL_RESEND_EMAIL,
    payload: { transactionDetail },
  };
}

export function cancelRefundBreakdown(transactionDetail) {
  return {
    type: REPORTS_TRANSACTIONS_CANCEL_REFUND_BREAKDOWN,
    payload: { transactionDetail },
  };
}

export function transactionShowLoadingSpinner(showLoadingSpinnerTransaction) {
  return {
    type: REPORTS_TRANSACTIONS_SHOW_LOADING_SPINNER,
    payload: { showLoadingSpinnerTransaction },
  };
}
